module.exports = __webpack_public_path__ + "img/p122.0f75b14b.jpg";